import React from 'react';

const IconRSS = () => (
  <svg
    fill="currentColor"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 1a4 4 0 0 0 -4 4v14a4 4 0 0 0 4 4h14a4 4 0 0 0 4 -4V5a4 4 0 0 0 -4 -4H5Zm-0.16 3.5H4.5v2.727h0.34c6.59 0 11.933 5.342 11.933 11.932v0.341H19.5v-0.34c0 -8.097 -6.563 -14.66 -14.66 -14.66ZM4.5 9.273h0.34c5.461 0 9.887 4.426 9.887 9.886v0.34H12v-0.34a7.16 7.16 0 0 0 -7.16 -7.16H4.5V9.274Zm0 7.84a2.386 2.386 0 1 1 4.773 0 2.386 2.386 0 0 1 -4.773 0Z"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeWidth="1"
      fill="currentColor"></path>
  </svg>
);
export default IconRSS;
